import script from "./DashboardSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardSummary.vue?vue&type=script&setup=true&lang=js"

import "./DashboardSummary.vue?vue&type=style&index=0&id=41a75506&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41a75506"]])

export default __exports__